import type { FilterableCustomField } from '@/models/customFieldFilterTypes';

// Only active dropdown fields can be filtered on; free-text fields have no options.
export const filterableCustomFields = (
  fields: FilterableCustomField[],
  entity: 'client' | 'matter',
): FilterableCustomField[] =>
  fields.filter((f) => f.entity === entity && f.type === 'enum' && f.active);
